import { render, staticRenderFns } from "./FollowUpMission.vue?vue&type=template&id=2e93c956&scoped=true&"
import script from "./FollowUpMission.vue?vue&type=script&lang=js&"
export * from "./FollowUpMission.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpMission.vue?vue&type=style&index=0&id=2e93c956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93c956",
  null
  
)

export default component.exports